import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BaseApiService } from '../baseApiService';
import { AuthenticationService } from '../../auth/authentication-service';
import { TraceableComponent } from './traceableComponent';
import { TraceableComponentNode } from './traceableComponentNode';

@Injectable({
  providedIn: 'root'
})
export class TraceableComponentsApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getAssetTraceableComponents(assetId: string, source: string): Observable<TraceableComponentNode[]> {
    const url = `${this.apiUrl}/assets/${assetId}/api/v5/traceable-components/${source}`;
    return this.http.get<TraceableComponentNode[]>(url).pipe(
      catchError(this.handleError<TraceableComponentNode[]>('getAssetCurrentTraceableComponents', undefined))
    );
  }

  getTraceableComponentChildren(id: number, source: string): Observable<TraceableComponentNode[]> {
    const url = `${this.apiUrl}/api/v5/traceable-components/${source}/${id}/children`

    return this.http.get<TraceableComponentNode[]>(`${this.apiUrl}/api/v5/traceable-components/current/${id}/children`).pipe(
      catchError(this.handleError<TraceableComponentNode[]>('getCurrentTraceableComponentChildren', undefined))
    );
  }

  getTraceableComponent(id: number, source: string): Observable<TraceableComponent> {
    const url = `${this.apiUrl}/api/v5/traceable-components/${source}/${id}`

    return this.http.get<TraceableComponent>(url).pipe(
      catchError(this.handleError<TraceableComponent>('getCurrentTraceableComponent', undefined))
    );
  }
}
